export default {
  state: {
    occurrenceData: {},
    counselorData: {},
    vigilanceData: {},
    occurrenceRegData: {},
    patientOccurrence: {},
    patientVigilance: {},
    screeningData: {},
    applicationData: {},
  },

  getters: {
    getOccurrenceData(state) {
      return state.occurrenceData;
    },

    getCounselorData(state) {
      return state.counselorData;
    },
    getVigilanceData(state) {
      return state.vigilanceData;
    },
    getOccurrenceRegData(state) {
      return state.occurrenceRegData;
    },

    getPatientOccurrenceData(state) {
      return state.patientOccurrence;
    },

    getPatientVigilanceData(state) {
      return state.patientVigilance;
    },

    getScreeningData(state) {
      return state.screeningData;
    },
    getApplicationData(state) {
      return state.applicationData;
    },
  },

  mutations: {
    setVigilanceData(state, data) {
      state.vigilanceData = data;
    },

    setOccurrenceData(state, data) {
      const isNull = data === null;

      state.occurrenceData = {
        id: !isNull ? data.id : "",
        created_at: !isNull ? data.created_at : "",
        date: !isNull ? data.date : "",
        treatment_id: !isNull ? data.id : "",
        patient_id: !isNull ? data.patient_id : "",
        occurrence_id: !isNull ? +data.occurrence_id : "",
        name: !isNull ? data.patient?.name : "",
        social_name: !isNull ? data.patient?.social_name : "",
        event_id: !isNull ? data.event_id : "",
        counselingPatient: !isNull ? data.counselingPatient : [],
      };
    },

    setCounselorData(state, data) {
      const isNull = data === null;

      let filtro = data.resultExams.filter((item) => item.exam_id == "1");
      let _ = [];
      for (const item of filtro) _.push(item.id);
      let _id_max = Math.max(..._);
      let _id_min = Math.min(..._);

      state.counselorData = {
        id: !isNull ? data.id : "",
        treatment_id: !isNull ? data.id : "",
        treatment_number: !isNull ? data.treatment_number : "",
        cpf: !isNull ? data.patient?.cpf : "",
        cns: !isNull ? data.patient?.cns : "",
        rg: !isNull ? data.patient?.rg : "",
        name: data.patient?.social_name
          ? data.patient?.social_name
          : data.patient?.name,
        date: !isNull ? data.date : "",
        gender_id: !isNull ? +data.patient?.gender_id : "",

        status_exam_hiv:
          _.length === 2
            ? filtro.find((item) => item.id === _id_min)
            : data.resultExams.find((item) => item.exam_id === "1"),
        // status_exam_hiv: !isNull ? data.resultExams.find((item) => item.id === _id_min) : "",
        status_exam_hiv_second:
          _.length === 2 ? filtro.find((item) => item.id === _id_max) : "",

        // status_exam_sifilis : !isNull ? data.resultExams[1]?.status_exam_id : "",
        status_exam_sifilis: !isNull
          ? data.resultExams.find((item) => item.exam_id === "2")
          : "",
        // status_exam_hb : !isNull ? data.resultExams[2]?.status_exam_id : "",
        status_exam_hb: !isNull
          ? data.resultExams.find((item) => item.exam_id === "3")
          : "",
        // status_exam_hc : !isNull ? data.resultExams[3]?.status_exam_id : "",
        status_exam_hc: !isNull
          ? data.resultExams.find((item) => item.exam_id === "4")
          : "",

        counselingPatient: !isNull ? data.counselingPatient : "",
        created_at: !isNull ? data.created_at : "",
        event_id: !isNull ? data.event_id : "",
      };
    },

    setOccurrenceRegData(state, data) {
      const isNull = data === null;

      state.occurrenceRegData = {
        id: !isNull ? data?.id : "",
        treatment_number: !isNull ? data?.treatment_number : "",
        occurrence_id: !isNull ? data?.occurrence_id : "",
        causes: !isNull ? data?.occurrence?.causes : [],
        date: !isNull ? data?.occurrence?.date : "",
        diagnosis: !isNull ? data?.occurrence?.diagnosis : [],
        event: !isNull ? data?.occurrence?.event : {},
        event_id: !isNull ? +data?.event_id : "",
        health_center_id: !isNull
          ? +data?.occurrence?.health_center_id
          : "",
        health_center: !isNull ? data?.occurrence?.health_center : "",
        origin_id: !isNull ? +data?.occurrence?.origin_id : "",
        procedures: !isNull ? data?.occurrence?.procedures : [],
        professional: !isNull ? data?.occurrence?.professional : {},
        professional_id: !isNull
          ? +data?.occurrence?.professional_id
          : "",
         provenance: {
          id: !isNull ? (data.occurrence?.provenance?.id ?? data.occurrence?.provenance_id) : "",
          name: !isNull ? (data.occurrence?.provenance?.name ?? data.occurrence?.provenance_name) : "",
        },

        provenance_status: {
          id: !isNull ? (data.occurrence?.provenance_status_id ?? data.occurrence?.provenance_status?.id) : "",
          name: !isNull ? (data.occurrence?.provenance_status_name ?? data.occurrence?.provenance_status?.name) : "", 
        },

        resoluteness: {
          description: !isNull
            ? data?.occurrence?.resoluteness?.description
            : "",
          description_death: !isNull
            ? data?.occurrence?.resoluteness?.description_death
            : "",
          destination_unity_id: !isNull
            ? +data?.occurrence?.resoluteness?.destination_unity_id
            : "",
          end_date: !isNull ? data?.occurrence?.resoluteness?.end_date : "",
          id: !isNull ? +data?.occurrence?.resoluteness?.id : "",
          name: !isNull ? data?.occurrence?.resoluteness?.name : "",
        },
        resoluteness_historical: !isNull
          ? data?.occurrence?.resoluteness_historical
          : [],
        type_aggressions: !isNull ? data?.occurrence?.type_aggressions : [],
        unity: !isNull ? data?.unity : {},
        user_name: !isNull ? data?.user_name : "",
        risk_rating_id: !isNull ? +data?.risk_rating_id : "",
      };
    },

    setPatientOccurrenceData(state, data) {
      const isNull = data === null;
      state.patientOccurrence = {
        id: !isNull ? data.id : "",
        patient_id: !isNull ? data.patient_id : "",
        created_at: !isNull ? data.created_at : "",
        apparent_age: !isNull ? data.patient?.apparent_age : "",
        authorization_cell_number: !isNull
          ? data.patient?.authorization_cell_number
          : "",
        authorization_email: !isNull ? data.patient?.authorization_email : "",
        breed_id: !isNull ? +data.patient?.breed_id : "",
        cep: !isNull ? data.patient?.cep : "",
        cns: !isNull ? data.patient?.cns : "",
        county_reference_id: !isNull
          ? +data.patient?.county_reference_id
          : "",
        cpf: !isNull ? data.patient?.cpf : "",
        date_of_birth: !isNull
          ? data.patient?.date_of_birth?.substring(0, 10)
          : "",
        education_id: !isNull ? +data.patient?.education_id : "",
        father_name: !isNull ? data.patient?.father_name : "",
        foreiner_activated: !isNull
          ? +data.patient?.foreiner_activated === 1
            ? true
            : +data.patient?.foreiner_activated === 0
            ? false
            : data.patient?.foreiner_activated
          : false,
        gender_id: !isNull ? +data.patient?.gender_id : "",
        has_documents: !isNull ? data.patient?.has_documents : "",
        health_condition: !isNull ? data.patient?.health_condition : [],
        identification_patient: !isNull
          ? data.patient?.identification_patient
          : "",
        ignored_patient: !isNull
          ? +data.patient?.ignored_patient === 1
            ? true
            : +data.patient?.ignored_patient === 0
            ? false
            : data.patient?.ignored_patient
          : false,
        marital_status_id: !isNull
          ? +data.patient?.marital_status_id
          : "",
        mother_name: !isNull ? data.patient?.mother_name : "",
        name: !isNull ? data.patient?.name : "",
        nationality: !isNull ? data.patient?.nationality : "",
        naturalness: !isNull ? data.patient?.naturalness : "",
        neighborhood: !isNull ? data.patient?.neighborhood : "",
        number_address: !isNull ? data.patient?.number_address : "",
        observation: !isNull ? data.patient?.observation : "",
        origin_document: !isNull ? data.patient?.origin_document : "",
        passport: !isNull ? data.patient?.passport : "",
        patient_type_id: !isNull ? +data.patient?.patient_type_id : "",
        patient_without_document: !isNull
          ? +data.patient?.patient_without_document === 1
            ? true
            : +data.patient?.patient_without_document === 0
            ? false
            : data.patient?.patient_without_document
          : false,
        phone_number: !isNull ? data.patient?.phone_number : "",
        provenance_id: !isNull ? +data.patient?.provenance?.id : "",
        provenance_name: !isNull ? data.patient?.provenance?.name : "",
        provenance_status: !isNull ? data.patient?.provenance_status : "",
        provenance_status_id: !isNull
          ? +data.patient?.provenance_status_id
          : "",
        provenance_status_name: !isNull
          ? data.patient?.provenance_status_name
          : "",
        provenance: {
          id: !isNull ? data.patient?.provenance?.id : "",
          name: !isNull ? data.patient?.provenance?.name : "",
        },
        public_place: !isNull ? data.patient?.public_place : "",
        qrcode: !isNull ? data.patient?.qrcode : "",
        rg: !isNull ? data.patient?.rg : "",
        sex_id: !isNull ? +data.patient?.sex_id : "",
        social_name: !isNull ? data.patient?.social_name : "",
        state_reference_id: !isNull
          ? +data.patient?.state_reference_id
          : "",
        event: {
          id: !isNull ? data.event?.id : "",
          name: !isNull ? data.event?.name : "",
          year: !isNull ? data.event?.year : "",
        },
        event_id: !isNull ? +data.event_id : "",
      };
    },
    setPatientVigilanceData(state, data) {
      const isNull = data === null;
      state.patientVigilance = {
        id: !isNull ? data.id : "",
        treatment_number: !isNull ? data.treatment_number : "",
        event_id: !isNull ? +data.event_id : "",
        event: {
          id: !isNull ? data.event?.id : "",
          name: !isNull ? data.event?.name : "",
          year: !isNull ? data.event?.year : "",
        },
        date: !isNull ? data.date : "",
        patient_id: !isNull ? +data.patient_id : "",
        apparent_age: !isNull ? data.patient?.apparent_age : "",
        authorization_cell_number: !isNull
          ? data.patient?.authorization_cell_number
          : "",
        authorization_email: !isNull ? data.patient?.authorization_email : "",
        breed_id: !isNull ? +data.patient?.breed_id : "",
        cep: !isNull ? data.patient?.cep : "",
        cns: !isNull ? data.patient?.cns : "",
        county_reference_id: !isNull
          ? +data.patient?.county_reference_id
          : 0,
        cpf: !isNull ? data.patient?.cpf : "",
        date_of_birth: !isNull ? data.patient?.date_of_birth?.substring(0, 10) : "",
        education_id: !isNull ? +data.patient?.education_id : "",
        father_name: !isNull ? data.patient?.father_name : "",
        foreiner_activated: !isNull
          ? +data.patient?.foreiner_activated === 1
            ? true
            : +data.patient?.foreiner_activated === 0
            ? false
            : data.patient?.foreiner_activated
          : false,
        gender_id: !isNull ? +data.patient?.gender_id : "",
        has_documents: !isNull ? data.patient?.has_documents : "",
        health_condition: !isNull ? data.patient?.health_condition : [],
        identification_patient: !isNull
          ? data.patient?.identification_patient
          : "",
        ignored_patient: !isNull
          ? +data.patient?.ignored_patient === 1
            ? true
            : +data.patient?.ignored_patient === 0
            ? false
            : data.patient?.ignored_patient
          : false,
        marital_status_id: !isNull
          ? +data.patient?.marital_status_id
          : null,
        mother_name: !isNull ? data.patient?.mother_name : "",
        name: !isNull ? data.patient?.name : "",
        nationality: !isNull ? data.patient?.nationality : "",
        naturalness: !isNull ? data.patient?.naturalness : "",
        neighborhood: !isNull ? data.patient?.neighborhood : "",
        number_address: !isNull ? data.patient?.number_address : "",
        observation: !isNull ? data.patient?.observation : "",
        origin_document: !isNull ? data.patient?.origin_document : "",
        passport: !isNull ? data.patient?.passport : "",
        patient_type_id: !isNull ? +data.patient?.patient_type_id : null,
        patient_without_document: !isNull
          ? +data.patient?.patient_without_document === 1
            ? true
            : +data.patient?.patient_without_document === 0
            ? false
            : data.patient?.patient_without_document
          : false,
        phone_number: !isNull ? data.patient?.phone_number : "",
        public_place: !isNull ? data.patient?.public_place : "",
        qrcode: !isNull ? data.patient?.qrcode : "",
        rg: !isNull ? data.patient?.rg : "",
        sex_id: !isNull ? +data.patient?.sex_id : "",
        social_name: !isNull ? data.patient?.social_name : "",
        state_reference_id: !isNull
          ? +data.patient?.state_reference_id
          : "",
        unity: !isNull
          ? data.unity
          : {
              id: !isNull ? data.unity?.id : "",
              name: !isNull ? data.unity?.name : "",
            },
        health_center: !isNull ? data.health_center : "",
        health_center_id: !isNull ? +data.health_center_id : "",
        statusTreatment: !isNull ? data.statusTreatment : {},
        priority: !isNull ? data.priority : null, 
      };
    },
    setScreeningData(state, data) {
      const isNull = data === null;

      state.screeningData = {
        category_id: !isNull ? +data.category_id : "",
        subcategory_id: !isNull ? +data.subcategory_id : "",
        strategy_id: !isNull ? +data.strategy_id : "",
        application_date: !isNull ? data.application_date.slice(0, 10) : "",
        vaccine_name: !isNull ? data.vaccine_name : "",
        vaccine_batch: !isNull ? data.vaccine_batch : "",
        dose_id: !isNull ? +data.dose_id : "",
        application_location_id: !isNull
          ? +data.application_location_id
          : "",
        vaccines: !isNull ? data.vaccines : [],
        ocurrence_vaccine_vaccines: !isNull
          ? data.ocurrence_vaccine_vaccines
          : [],
        category: {
          name: !isNull ? data.category?.name : "",
        },
        subcategory: {
          name: !isNull ? data.subcategory?.name : "",
        },
        strategy: {
          name: !isNull ? data.strategy?.name : "",
        },
      };
    },
    setApplicationData(state, data) {
      const isNull = data === null;
      state.applicationData = {
        treatment_id: !isNull ? data.treatment_id : null,
        application_date: !isNull ? data.application_date : null,
        category_id: !isNull ? data.category_id : null,
        subcategory_id: !isNull ? data.subcategory_id : null,
        strategy_id: !isNull ? data.strategy_id : null,
        category: {
          name: !isNull ? data.category?.name : null,
        },
        subcategory: {
          name: !isNull ? data.subcategory?.name : null,
        },
        strategy: {
          name: !isNull ? data.strategy?.name : null,
        },
        ocurrence_vaccine_vaccines: !isNull
          ? data.ocurrence_vaccine_vaccines
          : [],
      };
    },
  },

  actions: {
    changeOccurrenceData(context, infos) {
      context.commit("setOccurrenceData", infos);
    },
    changeCounselorData(context, infos) {
      context.commit("setCounselorData", infos);
    },
    changeVigilanceData(context, infos) {
      context.commit("setVigilanceData", infos);
    },
    changeOccurrenceRegData(context, infos) {
      context.commit("setOccurrenceRegData", infos);
    },

    changePatientOccurrenceData(context, infos) {
      context.commit("setPatientOccurrenceData", infos);
    },
    changePatientVigilanceData(context, infos) {
      context.commit("setPatientVigilanceData", infos);
    },

    changeScreeningData(context, infos) {
      context.commit("setScreeningData", infos);
    },

    changeApplicationData(context, infos) {
      context.commit("setApplicationData", infos);
    },
  },
};
